import React from 'react';

import { Input } from '@amzn/storm-ui';
import { FormRow } from '@amzn/storm-ui-column-form-kit';

import { Option } from '../../../BookingManagement/components/CreateBooking/interface/FormFieldInterfaces';
import { StatusTypes } from '../../constants/statusTypes';

interface FormInputFieldProps extends Option {
  onChange?: (value: string) => void;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
}

export const FormInputField: React.FC<FormInputFieldProps> = ({
  id,
  label,
  value,
  onChange = () => {},
  placeholder = '',
  error = '',
  disabled = false,
}) => (
  <FormRow
    id={id}
    label={label}
    controlComponents={[
      (componentId) => (
        <Input
          id={componentId}
          fullWidth
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          value={value}
          statusType={error ? StatusTypes.ERROR : StatusTypes.SUCCESS}
          message={error || ''}
          disabled={disabled}
        />
      ),
    ]}
  />
);
